import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutPreview from "./sections/AboutPreview";
import ProductsServicesPreview from "./sections/ProductsServicesPreview";
import OperationsPreview from "./sections/OperationsPreview";
import RequestAQuote from "./sections/RequestAQuote";
import BlogPreview from "./sections/BlogPreview";
import ContactCta from "./sections/ContactCta";
import CaseTypesGrid from "./sections/CaseTypesGrid";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutPreview />
      <ProductsServicesPreview />
      <OperationsPreview />
      <CaseTypesGrid />
      <RequestAQuote />
      <BlogPreview />
      <ContactCta />
      <Footer />
    </div>;
}